import { LocalStorageWithFallback } from './callback/localStorageWithFallback';

export function persistOtParamsToLocalStorage(
  incomingEntries: Record<string, string>,
) {
  const localStorage = new LocalStorageWithFallback();
  for (const [k, v] of Object.entries(incomingEntries)) {
    localStorage.set(`ot_${k}`, v);
  }
}
